// extracted by mini-css-extract-plugin
export default {"root":"styles_root__iLAw2","title":"styles_title__Qkzd9","reviewText":"styles_reviewText__N8WRQ"};